import type {
  FundBankAccountTransactionListResponse,
  FundBankTransactionQueryParams,
} from '@/types/fund-bank-transactions';
import { apiClient } from '@/utils/api-client';

// Helper function to build query string
function buildQueryString(params: Record<string, unknown>): string {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value));
    }
  });
  return searchParams.toString();
}

export class BankTransactionService {
  /**
   * Get bank account transactions for a fund (paginated, newest first).
   * Backed by the fund-scoped endpoint that aggregates every bank account.
   */
  static async getBankTransactions(
    fundId: string,
    params: FundBankTransactionQueryParams = {}
  ): Promise<FundBankAccountTransactionListResponse> {
    const queryString = buildQueryString(params);
    return apiClient.get<FundBankAccountTransactionListResponse>(
      `/funds/${fundId}/bank-accounts/transactions?${queryString}`
    );
  }
}
